var exports = {
  "G8": "symbolWrapper__p3VO3P",
  "vZ": "symbolWrapperCompact__Dz2hHs",
  "tW": "symbolBackground__DuMEzB",
  "p6": "symbolLabel__qWp4LC",
  "c9": "symbolLabelSmall__OKTuev",
  "iL": "symbolLabelMedium__cFagPq",
};

module.exports = exports;
